import script from "./AdminEmployeeDocumentsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminEmployeeDocumentsView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminEmployeeDocumentsView.vue?vue&type=style&index=0&id=fee0c37e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee0c37e"]])

export default __exports__